// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"0bea91f5","323":"b563cfc6","366":"90c27404","453":"776b4381"}[chunkId] + ".chunk.js";
};